'use client';

import React, { useEffect, useMemo, useState } from 'react';

function pad2(n) {
    const s = String(n);
    return s.length === 1 ? `0${s}` : s;
}

function getTimeLeft(targetMs) {
    const now = Date.now();
    const diff = Math.max(0, targetMs - now);

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds, done: diff === 0 };
}

function CountdownBox({ value, label, accent }) {
    return (
        <div className="flex flex-col items-center gap-1 justify-center">
            <div className="min-w-[66px] rounded-md px-1 py-2 text-center text-xl font-bold text-primary sm:min-w-[76px] bg-white">
                {value}
            </div>
            <div className="text-[10px] font-medium tracking-[0.22em] text-white/80">{label}</div>
        </div>
    );
}

export default function OfferCountdown({
    accent = '#2c68b1',
    targetDate = '', // ISO string
    durationDays = 47, // fallback if no targetDate provided
    showLabels = true,
    className = '',
}) {
    const targetMs = useMemo(() => {
        if (targetDate) {
            const ms = new Date(targetDate).getTime();
            return Number.isFinite(ms) ? ms : Date.now() + durationDays * 24 * 3600 * 1000;
        }
        return Date.now() + durationDays * 24 * 3600 * 1000;
    }, [targetDate, durationDays]);

    const [left, setLeft] = useState(() => getTimeLeft(targetMs));

    useEffect(() => {
        const t = setInterval(() => setLeft(getTimeLeft(targetMs)), 1000);
        return () => clearInterval(t);
    }, [targetMs]);

    return (
        <div className={`flex flex-wrap items-end gap-2 ${className}`}>
            <CountdownBox
                value={pad2(left.days)}
                label={showLabels ? 'DAYS' : ''}
                accent={accent}
            />
            <span className="pb-6 text-xl font-bold text-white">:</span>

            <CountdownBox
                value={pad2(left.hours)}
                label={showLabels ? 'HOURS' : ''}
                accent={accent}
            />
            <span className="pb-6 text-xl font-bold text-white">:</span>

            <CountdownBox
                value={pad2(left.minutes)}
                label={showLabels ? 'MINUTES' : ''}
                accent={accent}
            />
            <span className="pb-6 text-xl font-bold text-white">:</span>

            <CountdownBox
                value={pad2(left.seconds)}
                label={showLabels ? 'SECONDS' : ''}
                accent={accent}
            />
        </div>
    );
}
